import {useQuery} from 'react-query'
import {ThemeEditModalForm} from './ThemeEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialTheme } from '../core/_models'

const ThemeEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: Theme,
    error,
  } = useQuery(
    `${QUERIES.THEMES_LIST}-theme-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/themes")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ThemeEditModalForm isThemeLoading={isLoading} Theme={{...initialTheme, _id: undefined}} />
  }

  if (!isLoading && !error && Theme) {
    return <ThemeEditModalForm isThemeLoading={isLoading} Theme={Theme} />
  }

  return null
}

export {ThemeEditModalFormWrapper}
